export default __webpack_public_path__ + "static/media/Play.801b297c.png";